import { render, staticRenderFns } from "./rightRecommend.vue?vue&type=template&id=92a38f5e&scoped=true&"
import script from "./rightRecommend.vue?vue&type=script&lang=js&"
export * from "./rightRecommend.vue?vue&type=script&lang=js&"
import style0 from "./rightRecommend.vue?vue&type=style&index=0&id=92a38f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a38f5e",
  null
  
)

export default component.exports